import { sentryQabConfig } from './sentryConfig';

export const sentryConfigActivationAffiliateClub = {
  ...sentryQabConfig,
  dsn: 'https://6ddc5063c42ce643c092b885d8e81a5b@o207017.ingest.sentry.io/4505979784724480',
};
